import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import Tooltip from 'uikit/Tooltip';

import styles from './QuestionTypeCard.module.scss';

const cx = classNames.bind(styles);

const QuestionTypeCard = ({ className, handleQuestionCreate, info, t }) => (
  <Tooltip tooltip={t(info.tooltip)}>
    <button
      className={cx('container', className)}
      data-testid={`create-${info.type}-button`}
      onClick={handleQuestionCreate}
      type="button"
    >
      {info.isNew && (
        <div className={cx('new')}>
          {t('Course/Shared/QuestionEdit/QuestionTypeCard/new')}
        </div>
      )}
      <div className={cx('picture-container')}>
        <img className={cx('picture')} alt="" src={info.picture} />
      </div>
      <p className={cx('title')}>{t(info.name)}</p>
    </button>
  </Tooltip>
);

QuestionTypeCard.propTypes = {
  className: PropTypes.string,
  handleQuestionCreate: PropTypes.func.isRequired,
  info: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

QuestionTypeCard.defaultProps = {
  className: undefined,
};

export default QuestionTypeCard;
